export const QA_NAME_EMAIL_PROFILE_PAGE = 'EmailProfile'

export const EMAIL_PROFILE_REQUEST_DRAFT_PREFIX = 'email-profile-request'

export const EMAIL_PROFILE_REQUEST_WIZARD_DRAFT_PREFIX =
  'email-profile-request-wizard'
